<div  class="component-container padding-top-x2">
  @if (errorMessage) {
    <mat-error class="error">
      {{errorMessage}}
    </mat-error>
  }
  <form [formGroup]="form" (ngSubmit)="onSubmit()" >
    <mat-form-field>
      <input #employer matInput placeholder="Employer Name *" formControlName="employer">
      @if (employer.touched && employer.invalid) {
        <mat-error>
          {{getEmployerNameErrorMessage()}}
        </mat-error>
      }
    </mat-form-field>
    <div >
      <mat-form-field class="half-width">
        <input matInput placeholder="From date *" [matDatepicker]="fromDate" formControlName="fromDate" [max]="maxDate" (focus)="fromDate.open()" (click)="fromDate.open()">
        <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
        <mat-datepicker touchUi="true"  #fromDate></mat-datepicker>
        @if (fromDate.touched && fromDate.invalid) {
          <mat-error>
            {{getFromDateErrorMessage()}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="half-width">
        <input matInput placeholder="To date *" [matDatepicker]="toDate" formControlName="toDate" [max]="maxDate" (focus)="toDate.open()" (click)="toDate.open()">
        <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker touchUi="true" #toDate></mat-datepicker>
        @if (toDate.touched && toDate.invalid) {
          <mat-error>
            {{getToDateErrorMessage()}}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <mat-form-field>
      <input matInput placeholder="Position held *" formControlName="position">
      @if (position.touched && position.invalid) {
        <mat-error>
          {{getPositionHeldErrorMessage()}}
        </mat-error>
      }
    </mat-form-field>
    <div class="full-width padding-top-x1">
      <button class="half-width margin-bottom"
        mat-raised-button
        color="primary"
        type="submit"
      [disabled]="form.pristine || !form.valid || loading">Save</button>
      <button class="half-width margin-bottom"
        mat-raised-button
        (click)="onCancel();"
      color="primary">Cancel</button>
    </div>
  </form>
</div>
